import './Description.less';
export { default as Description } from './Description.js';
export { default } from './Description.js';